import type { Onboarding } from "@redotech/account-common/onboarding";
import type { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { getCurrentOnboarding } from "../client/onboarding";
import {
  getInitialFirstInstallStep,
  type FirstInstallStep,
} from "./first-install-flow";

const TERMS_REFETCH_DELAY_MS = 1500;

// A brand-new install can race the server's onboarding-doc creation; when the
// first read says "terms", refetch once after a short delay before committing.
export async function loadInitialFirstInstallStep(
  client: RedoMerchantClient,
  signal: AbortSignal,
): Promise<{ step: FirstInstallStep | null; data: Onboarding }> {
  const data = await getCurrentOnboarding(client, { signal });
  const step = getInitialFirstInstallStep(data);
  if (step !== "terms") {
    return { step, data };
  }
  await new Promise((resolve) => setTimeout(resolve, TERMS_REFETCH_DELAY_MS));
  if (signal.aborted) {
    return { step, data };
  }
  const retry = await getCurrentOnboarding(client, { signal });
  return { step: getInitialFirstInstallStep(retry), data: retry };
}
